export const objectHasEntries = (object: Record<string, unknown>): boolean => {
  return Object.values(object).some((value) => value !== undefined);
};
